import { LitElement, css, html } from 'lit'
import { customElement } from 'lit/decorators.js'

/**
 * A nav list
 */
@customElement('ep-nav-list-header')
export class EPNavListHeader extends LitElement {

  render() {
    return html`
      <h3>
        <slot></slot>
      </h3>
    `
  }

  static styles = css`
    :host {
      --font-prose: ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
      --color-soft-black: rgb(36, 41, 47);
      display: block;
    }

    * {
      box-sizing: border-box;
    }

    h3 {
      font-family: var(--font-prose);
      color: var(--color-soft-black);
      font-weight: 600;
      margin: 0px;
      font-size: 16px;
    }
  `
}

declare global {
  interface HTMLElementTagNameMap {
    'ep-nav-list-header': EPNavListHeader
  }
}
